import {
  IonApp,
  IonToolbar,
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonRouterOutlet,
  IonSplitPane,
  IonTitle,
  setupIonicReact,
  IonItem,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route } from "react-router-dom";
import SidebarLeft from "./SidebarLeft";
import Home from "./pages/Home";
import Zusatzstoffe from "./pages/Zusatzstoffe";
import Speisekarte from "./pages/Speisekarte";
import Mahlzeit from "./pages/Mahlzeit";
import Nahrung from "./pages/Nahrung";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import { useState } from "react";
import Login from "./pages/Login";
import Mittag from "./pages/Mittag";
import Stationen from "./pages/Stationen";
import Funktionen from "./pages/Funktionen";
import Bewohner from "./pages/Bewohner";
import TagIst from "./pages/TagIst";

import { DataContext } from "./context/DataContext";
import AppContext from "./context/AppContext";
import Stationsbedarf from "./pages/Stationsbedarf";

setupIonicReact();

const App = () => {
  const [appBewohnerZusatzstoffe, setAppBewohnerZusatzstoffe] = useState([]);
  const [appFunktion, setAppFunktion] = useState("");
  const [appHaeuser, setAppHaeuser] = useState([]);
  const [appHaus, setAppHaus] = useState("");
  const [appLoggedIn, setAppLoggedIn] = useState(false);

  /**
   * ! für AppStore-Prüfung: "https://login.saint-online.de/" als Default
   */
  // const [ appServer , setAppServer ] = useState( 'https://saint.ad.evkwesel.de/' ) ;
  // const [appServer, setAppServer] = useState("http://saint.ad.evkwesel.de/");
  const [appServer, setAppServer] = useState("https://login.saint-online.de/");

  const [appStationen, setAppStationen] = useState([]);
  const [appStationenMenues, setAppStationenMenues] = useState([]);
  const [appStation, setAppStation] = useState("");
  const [appToken, setToken] = useState("");
  const [appZusatzstoffe, setAppZusatzstoffe] = useState([]);
  const [appBewohnerId, setAppBewohnerId] = useState([]);
  const [appBewohnerSollId, setAppBewohnerSollId] = useState([]);
  const [appBewohnerSollBezeichnung, setAppBewohnerSollBezeichnung] = useState([]);
  const [appBewohnerIndex, setAppBewohnerIndex] = useState([]);
  const [ appBuildVersion, setAppBuildVersion ]: any = useState();
  const [appStationBezeichnung, setAppStationBezeichnung] = useState();
  const [appStationsbedarf, setAppStationsbedarf] = useState([]);
  const [appStationsbedarf1, setAppStationsbedarf1] = useState(true);
  const [appStationsbedarf2, setAppStationsbedarf2] = useState(true);
  const [appStationsbedarf3, setAppStationsbedarf3] = useState(true);
  const [appStationsbedarf4, setAppStationsbedarf4] = useState(true);
  const [appStationsbedarf5, setAppStationsbedarf5] = useState(true);
  const [appStationsbedarf6, setAppStationsbedarf6] = useState(true);
  const [appStationsbedarf7, setAppStationsbedarf7] = useState(true);
  const [appStationsbedarfMinBestellDate, setAppStationsbedarfMinBestellDate] = useState([]);
  const [appStationsbedarfFilter, setAppStationsbedarfFilter] = useState([]);
  const [appStationsbedarfVorlauf, setAppStationsbedarfVorlauf] = useState(36);
  const [appSollReloadAuswahl, setAppSollReloadAuswahl] = useState();
  const [appSollReloadBestellstatus, setAppSollReloadBestellstatus] = useState();
  const [ appVersion, setAppVersion ]: any = useState();

  let dataContextValue = {
    appBewohnerZusatzstoffe: appBewohnerZusatzstoffe,
    appBewohnerZusatzstoffeChange: setAppBewohnerZusatzstoffe,
    appFunktion: appFunktion,
    appFunktionChange: setAppFunktion,
    appBewohnerId: appBewohnerId,
    appBewohnerIdChange: setAppBewohnerId,

    appBewohnerSollId: appBewohnerSollId,
    appBewohnerSollIdChange: setAppBewohnerSollId,
    appBewohnerSollBezeichnung: appBewohnerSollBezeichnung,
    appBewohnerSollBezeichnungChange: setAppBewohnerSollBezeichnung,
    appBewohnerIndex: appBewohnerIndex,
    appBewohnerIndexChange: setAppBewohnerIndex,
    appBuildVersion: appBuildVersion,
    appBuildVersionChange: setAppBuildVersion,
    appHaeuser: appHaeuser,
    appHaeuserChange: setAppHaeuser,
    appHaus: appHaus,
    appHausChange: setAppHaus,
    appLoggedIn: appLoggedIn,
    appLoggedInChange: setAppLoggedIn,
    appServer: appServer,
    appServerChange: setAppServer,
    appStationen: appStationen,
    appStationenChange: setAppStationen,
    appStation: appStation,
    appStationChange: setAppStation,
    appStationBezeichnung: appStationBezeichnung,
    appStationBezeichnungChange: setAppStationBezeichnung,
    appToken: appToken,
    appTokenChange: setToken,
    appVersion: appVersion,
    appVersionChange: setAppVersion,
    appZusatzstoffe: appZusatzstoffe,
    appZusatzstoffeChange: setAppZusatzstoffe,
    appStationenMenues: appStationenMenues,
    appStationenMenuesChange: setAppStationenMenues,
    appStationsbedarf: appStationsbedarf,
    appStationsbedarfChange: setAppStationsbedarf,
    appStationsbedarf1: appStationsbedarf1,
    appStationsbedarf1Change: setAppStationsbedarf1,
    appStationsbedarf2: appStationsbedarf2,
    appStationsbedarf2Change: setAppStationsbedarf2,
    appStationsbedarf3: appStationsbedarf3,
    appStationsbedarf3Change: setAppStationsbedarf3,
    appStationsbedarf4: appStationsbedarf4,
    appStationsbedarf4Change: setAppStationsbedarf4,
    appStationsbedarf5: appStationsbedarf5,
    appStationsbedarf5Change: setAppStationsbedarf5,
    appStationsbedarf6: appStationsbedarf6,
    appStationsbedarf6Change: setAppStationsbedarf6,
    appStationsbedarf7: appStationsbedarf7,
    appStationsbedarf7Change: setAppStationsbedarf7,
    appStationsbedarfFilter: appStationsbedarfFilter,
    appStationsbedarfFilterChange: setAppStationsbedarfFilter,
    appStationsbedarfVorlauf: appStationsbedarfVorlauf,
    appStationsbedarfVorlaufChange: setAppStationsbedarfVorlauf,
    appStationsbedarfMinBestellDate: appStationsbedarfMinBestellDate,
    appStationsbedarfMinBestellDateChange: setAppStationsbedarfMinBestellDate,
    appSollReloadAuswahl: appSollReloadAuswahl,
    appSollReloadAuswahlChange: setAppSollReloadAuswahl,
    appSollReloadBestellstatus: appSollReloadBestellstatus,
    appSollReloadBestellstatusChange: setAppSollReloadBestellstatus,
  };

  const mk_content = (show: "login" | "pane") => {
    if (show === "login")
      return (
        <>
          {mk_header()}
          <Login />
        </>
      );
    return (
      <IonReactRouter>
        {mk_header()}
        <IonContent fullscreen>
          <IonSplitPane when="(min-width: 2024px)" contentId="main">
            <SidebarLeft />
            <IonPage id="main">
              <IonRouterOutlet>
                <Route exact path="/">
                  <Home />
                </Route>
                <Route exact path="/home">
                  <Home />
                </Route>
                <Route exact path="/stationen">
                  <Stationen />
                </Route>
                <Route exact path="/bewohner/:stationsid/:stationsbezeichnung">
                  <Bewohner modus='soll'/>
                </Route>
                <Route exact path="/bewohnerist/:stationsid/:stationsbezeichnung">
                  <Bewohner modus='ist'/>
                </Route>
                <Route exact path="/tag/:mahlzeit/:datum/:bewohnerid/:bewohnerbezeichnung">
                  <TagIst />
                </Route>
                <Route exact path="/funktionen/:stationsid/:stationsbezeichnung">
                  <Funktionen />
                </Route>
                <Route exact path="/stationsbedarf/:stationsid/:stationsbezeichnung">
                  <Stationsbedarf />
                </Route>
                <Route exact path="/speisekarte/:stationsid/:stationsbezeichnung/:bewohnerid/:bewohnerbezeichnung">
                  <Speisekarte />
                </Route>
                <Route exact path="/nahrung">
                  <Nahrung />
                </Route>
                <Route exact path="/mahlzeit/:zeit/:stationsid/:stationsbezeichnung/:tag/:woche/:bewohnerid/:bewohnerbezeichnung/:datumsql">
                  <Mahlzeit />
                </Route>
                <Route exact path="/mittag/:stationsid/:stationsbezeichnung/:tag/:woche/:bewohnerid/:bewohnerbezeichnung/:datumsql">
                  <Mittag />
                </Route>
                <Route exact path="/mahlzeit/:zeit/:stationsid/:stationsbezeichnung/:tag/:woche/:bewohnerid/:bewohnerbezeichnung/:datumsql">
                  <Mahlzeit />
                </Route>
                <Route exact path="/zusatzstoffe">
                  <Zusatzstoffe />
                </Route>
              </IonRouterOutlet>
            </IonPage>
          </IonSplitPane>
        </IonContent>
      </IonReactRouter>
    );
  };

  const mk_header = () => {
    return (
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton menu="start" auto-hide="false" color="primary"></IonMenuButton>
          </IonButtons>
          <IonItem button lines="none" routerLink="/home" routerDirection="back">
            <IonTitle>Senioren Menüerfassung</IonTitle>
          </IonItem>
        </IonToolbar>
      </IonHeader>
    );
  };

  return (
    <DataContext.Provider value={dataContextValue}>
      <AppContext />
      <IonApp>{!appLoggedIn ? mk_content("login") : mk_content("pane")}</IonApp>
    </DataContext.Provider>
  );
};

export default App;
